import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import { useI18n } from "@/i18n/i18n";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ConjugationDictionary } from "@/components/conjugation/ConjugationDictionary";
import { ConjugationPractice } from "@/components/conjugation/ConjugationPractice";
import { ConjugationTemplates } from "@/components/conjugation/ConjugationTemplates";
import { ConjugationGuide } from "@/components/conjugation/ConjugationGuide";

const KEY = "wss_conjugation_persons";

export default function Conjugation() {
  const { t } = useI18n();
  const { user } = useAuth();
  const canEdit = ["superadmin", "academic_director"].includes(user?.role);
  const [persons, setPersons] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || { vos: false, vosotros: false }; }
    catch { return { vos: false, vosotros: false }; }
  });

  const onTogglePerson = (which, value) => {
    const next = { ...persons, [which]: value };
    setPersons(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  };

  return (
    <div data-testid="conjugation-page">
      <PageHeader
        title={t("cj_title")}
        subtitle={t("cj_subtitle")}
        testId="conjugation-header"
        action={<ConjugationGuide />}
      />
      <Tabs defaultValue="practicar" className="mt-2">
        <TabsList>
          <TabsTrigger value="practicar" data-testid="conjugation-tab-practice">{t("cj_tab_practice")}</TabsTrigger>
          <TabsTrigger value="diccionario" data-testid="conjugation-tab-dictionary">{t("cj_tab_dictionary")}</TabsTrigger>
          {canEdit && (
            <TabsTrigger value="plantillas" data-testid="conjugation-tab-templates">{t("cjt_tab")}</TabsTrigger>
          )}
        </TabsList>
        <TabsContent value="practicar" className="mt-5">
          <ConjugationPractice showVos={persons.vos} showVosotros={persons.vosotros}
                               onTogglePerson={onTogglePerson} />
        </TabsContent>
        <TabsContent value="diccionario" className="mt-5">
          <ConjugationDictionary showVos={persons.vos} showVosotros={persons.vosotros}
                                 onTogglePerson={onTogglePerson} />
        </TabsContent>
        {canEdit && (
          <TabsContent value="plantillas" className="mt-5">
            <ConjugationTemplates />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
